/* eslint-disable import/no-anonymous-default-export */
import { notification } from "antd";
import { useEffect, useState } from "react";
import useCodigosInfraccionAPI from "./useCodigosInfraccionAPI";

export default () => {
    const api = useCodigosInfraccionAPI();
    const [categorias, setCategorias] = useState<{ value: string, text: string }[]>([]);
    
    const loadCategorias = async () => {
        const response = await api.listCategorias();

        if (response.error) {
            notification.error({
                message: "Error al listar categrías"
            })
            return;
        }

        setCategorias(response.data!.value.map((c : any) => ({ text: c.nombre, value: c.nombre })));
    };

    useEffect(()=>{
        loadCategorias();
    },[]);

    return {categorias}
}